import { Entity } from '../entity';

export interface PhaseProps {
    id: string;
    name: string;
    completed?: boolean;
    current?: boolean;
    nextPhaseId?: string;
    rootPhaseId?: string;
    icon?: string;
    lockedAt?: string;
}

export class Phase extends Entity {
    name: string;
    rootPhaseId?: string;
    current;
    nextPhaseId?: string;
    icon?: string;
    lockedAt?: string;

    constructor({
        id,
        name,
        current,
        rootPhaseId,
        nextPhaseId,
        icon,
        lockedAt,
    }: PhaseProps) {
        super({ id, name });
        this.name = name;
        this.rootPhaseId = rootPhaseId;
        this.nextPhaseId = nextPhaseId;
        this.current = current ?? false;
        this.icon = icon;
        this.lockedAt = lockedAt;
    }

    lock(): void {
        this.lockedAt = this.lockedAt ?? new Date().toJSON();
    }

    setCurrent(): void {
        this.current = true;
    }

    unsetCurrent(): void {
        this.current = false;
    }

    isCurrent(): boolean {
        return this.current;
    }

    isAfter(phase: Phase): boolean {
        return parseInt(this.id) > parseInt(phase.id);
    }
}
